import { StrictMode, useCallback, lazy, Suspense } from 'react'
import { HashRouter } from 'react-router-dom'

import {
  SacrificeStatsProvider,
  AuthProvider,
  useAuth,
  ProjectProvider,
  AdminProjectProvider,
  PreferencesProvider,
} from '../contexts'
import { InstanceAuthProvider } from '../contexts/InstanceAuthContext'
import {
  BelowFoldProvider,
  NameResolutionProvider,
  TokenMetadataProvider,
  ViewModeProvider,
} from '../contexts'
// import { ReferralProvider } from '../contexts'
import { AppKitWrapper } from './AppKitWrapper'
import { WagmiProviderWrapper } from './WagmiProviderWrapper'
import AppContent from './AppContent'
import { Scroller } from './Scroller'
import NavigationBar from './NavigationBar'
import { BottomNav } from './NavigationBar'
import { AuthCampaignReconciler } from './AuthCampaignReconciler'

const AuthWatcher = lazy(() => import('./AuthWatcher').then(m => ({ default: m.AuthWatcher })))

// Inner component that can use the SacrificeStatsProvider context
const LayoutInner = () => {
  const { isSignedIn, connectedAddress } = useAuth()
  // const { projectId } = useProjects()

  const { signOut } = useAuth()

  const handleLogout = useCallback(() => {
    // Clear authentication from the auth context
    signOut()
  }, [signOut])

  // Wallet state comes from AuthProvider via wagmi hooks
  // address and isConnected will be undefined/false until user clicks connect button
  const address = connectedAddress ?? undefined
  const isConnected = !!connectedAddress

  return (
    <>
      {/* Non-critical components - lazy loaded */}
      <Suspense fallback={null}>
        <AuthWatcher />
      </Suspense>
      {/* {projectId && (
        <Suspense fallback={null}>
          <ReferralPrompt />
        </Suspense>
      )} */}

      {/* Main content area - renders immediately without any wallet dependencies */}
      {/* AddressButton will load AppKit only when user clicks connect */}
      <Scroller vertical="scroll" horizontal="hidden" height="100vh">
        <NavigationBar
          address={address}
          isConnected={isConnected}
          isSignedIn={isSignedIn}
          onLogout={handleLogout}
          renderBottomNav={false}
        >
          <AppContent />
        </NavigationBar>
      </Scroller>

      {/* Bottom navigation - renders immediately */}
      <BottomNav
        address={address}
        isConnected={isConnected}
        isSignedIn={isSignedIn}
        onLogout={handleLogout}
      />
    </>
  )
}

// Wrapper component to conditionally render ReferralProvider based on projectId
// const ReferralWrapper = ({ children }: { children: React.ReactNode }) => {
//   const { projectId } = useProjects()

//   if (!projectId) {
//     return <>{children}</>
//   }

//   return <ReferralProvider projectId={projectId}>{children}</ReferralProvider>
// }

// Main Layout component that provides the context
const Layout = () => {
  return (
    <StrictMode>
      <PreferencesProvider>
        <WagmiProviderWrapper>
          <AuthProvider>
            <InstanceAuthProvider>
              <HashRouter>
                <AuthCampaignReconciler />
                <ProjectProvider>
                  <NameResolutionProvider>
                    {/* <ReferralWrapper> */}
                    <AdminProjectProvider>
                      <BelowFoldProvider>
                        <SacrificeStatsProvider>
                          <TokenMetadataProvider>
                            <ViewModeProvider>
                              <AppKitWrapper>
                                <LayoutInner />
                              </AppKitWrapper>
                            </ViewModeProvider>
                          </TokenMetadataProvider>
                        </SacrificeStatsProvider>
                      </BelowFoldProvider>
                    </AdminProjectProvider>
                    {/* </ReferralWrapper> */}
                  </NameResolutionProvider>
                </ProjectProvider>
              </HashRouter>
            </InstanceAuthProvider>
          </AuthProvider>
        </WagmiProviderWrapper>
      </PreferencesProvider>
    </StrictMode>
  )
}

export default Layout
